import React from 'react';

import isArchived from 'archive/isArchived';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import {ListableItem} from 'search/SearchConstants';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {ModelRunListingGraphQL} from '../../../../graphql-fragments/model-hub/__generated/ModelRunListingGraphQL';

interface ModelRunSidepanelItemProps {
  modelRun: ModelRunListingGraphQL;
  isActive: boolean;
  isCompact: boolean;
  isChild: boolean;
  openResult: (item: ListableItem) => void;
  dataTestAttrs?: DataTestAttrs;
}

export default function ModelRunSidepanelItem(props: ModelRunSidepanelItemProps): JSX.Element {
  const {modelRun, isActive, isCompact, isChild, dataTestAttrs} = props;
  // TODO(MODEL_RUN): Replace with actual model run icon when available
  const icon = <BenchlingIcon icon="microscope" />;

  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={isArchived(modelRun)}
      icon={icon}
      isCompact={isCompact}
      onClick={() => {
        props.openResult(modelRun as unknown as ListableItem);
      }}
      title={{
        text: modelRun.name,
        node: <span>{modelRun.name}</span>,
      }}
      tooltipText={modelRun.name}
      isExpandable={false}
      isChild={isChild}
      dataTestAttrs={dataTestAttrs}
    />
  );
}
